<template>
    <div>
        <li v-if="user_role ==='csm'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" :class="{ 'input-disabled' : checked_user < 1}"
				@click="openBulkModal('send_sms')">											
                <img width="18" src="../../assets/images/icons/solid/envelope.svg">
                <small class="ml-1">Send SMS</small>
		</li>
        <li  v-if="(user_role ==='csm' || user_role === 'organization') && user_meta_actions.includes('send_reset_pw_email') " class="pb-2 pt-2 d-flex align-items-center cursor-pointer">
			<div class="trigger-hidden-content ml-1 d-inline-block">
			<i class="fa fa-key fa-ninja fa-ninja-black" ></i>
            <small class="ml-1">Reset Password</small> <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
            
                <div class="hidden-content hc-right-bottom"> 
                    <div>
                        <ul class="list-unstyled text-left">
                            <li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" 
                            :class="{ 'input-disabled' : checked_user < 1  }" @click="openBulkModal('reset_password_email')">	
                                <i class="fa fa-sms fa-ninja fa-ninja-black"></i>
                                <small class="ml-1">Send Email</small>
                            </li>
                            <li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" 
                            :class="{ 'input-disabled' : checked_user < 1 }" @click="openBulkModal('reset_password_text')">	
                                <i class="fa fa-comment-dots fa-ninja fa-ninja-black"></i>
                                <small class="ml-1">Send Sms</small>
                            </li>
                            <li  v-if="user_role === 'csm'" class="pb-2 pt-2 d-flex
                                align-items-center cursor-pointer"
                                  :class="{ 'input-disabled' : checked_user != 1  }" @click="openBulkModal('reset_password_plain',item)">	
                                 <i class="fa fa-sms fa-ninja fa-ninja-black"></i>
                                <small class="ml-1">Set New Password</small>
                            </li>
                        </ul>
                    </div>
                </div>			
            </div>
		</li>
    </div>
</template>
<script>
export default {
    props:["user_role","checked_user", "item", "sign_up"],
    data: function() {
        return{
            user_meta_actions: localStorage.getItem('meta_actions')
        }
    },
    methods:{
        openBulkModal: function(param){
            // from top action menu, item prop will be empty
            if(this.item != null || this.item != ''){
                this.$parent.openBulkModal(param, this.item)

            }else{
                //if we call if from table actions then item will not ne empty
                this.$parent.openBulkModal(param)
            }
           
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PasswordActionItems.vue